import React from 'react';

export const RegionConfigContext = React.createContext(null);

export function RegionConfigProvider({ regionConfig, children }) {
  return (
    <RegionConfigContext.Provider value={regionConfig}>
      {children}
    </RegionConfigContext.Provider>
  );
}
